module.exports = __webpack_public_path__ + "static/img/arrow_left.883a373.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_left.svg
// module id = 429
// module chunks = 0